if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.productInfo = this.closest('product-info');
        (this.productInfo || this).addEventListener('change', this.clearFadropVariantOptionError.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (!this.validateFadropRequiredVariantOptions()) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      clearFadropVariantOptionError(event) {
        const optionGroup = event.target.closest?.('.product-form__input');
        if (!optionGroup || !optionGroup.closest('variant-selects')) return;

        optionGroup.classList.remove('fadrop-variant-option-error');

        const productInfo = this.productInfo || this.closest('product-info') || document;
        const hasMissingOptions = Array.from(productInfo.querySelectorAll('variant-selects .product-form__input')).some(
          (group) => group.classList.contains('fadrop-variant-option-error')
        );

        if (!hasMissingOptions) this.handleErrorMessage();
      }

      validateFadropRequiredVariantOptions() {
        const productInfo = this.productInfo || this.closest('product-info') || document;
        const variantSelects = productInfo.querySelector('variant-selects');
        if (!variantSelects) return true;

        const optionGroups = Array.from(variantSelects.querySelectorAll('.product-form__input'));
        const missingOptions = [];

        optionGroups.forEach((group) => {
          const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
          const select = group.querySelector('select');
          const label = group.querySelector('.form__label');
          const rawLabel = label?.textContent || select?.name || 'option';
          const optionName = rawLabel.replace(/[:*]/g, '').replace(/\s+/g, ' ').trim();
          const hasSelection = radios.length ? radios.some((radio) => radio.checked) : select ? Boolean(select.value) : true;

          group.classList.toggle('fadrop-variant-option-error', !hasSelection);
          if (!hasSelection) missingOptions.push(optionName);
        });

        if (!missingOptions.length && this.variantIdInput?.value) return true;

        const normalizedMissing = missingOptions.map((name) => name.toLowerCase());
        let message = 'Please select product options.';
        if (normalizedMissing.includes('color') && normalizedMissing.includes('size')) {
          message = 'Please select color and size.';
        } else if (missingOptions.length === 1) {
          message = `Please select ${missingOptions[0].toLowerCase()}.`;
        } else if (missingOptions.length > 1) {
          message = `Please select ${missingOptions.map((name) => name.toLowerCase()).join(' and ')}.`;
        }

        this.handleErrorMessage(message);
        optionGroups.find((group) => group.classList.contains('fadrop-variant-option-error'))?.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });

        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// FADROP: product pages should not auto-select color/size unless a variant URL was opened.
(() => {
  const clearInitialVariantSelections = () => {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    document.querySelectorAll('product-info variant-selects').forEach((variantSelects) => {
      if (variantSelects.dataset.fadropInitialSelectionCleared === 'true') return;
      variantSelects.dataset.fadropInitialSelectionCleared = 'true';

      variantSelects.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
      });

      variantSelects.querySelectorAll('select').forEach((select) => {
        select.querySelectorAll('option[selected]').forEach((option) => option.removeAttribute('selected'));
        select.selectedIndex = -1;
      });

      variantSelects.querySelectorAll('[data-selected-value]').forEach((value) => {
        value.textContent = '';
      });

      const productInfo = variantSelects.closest('product-info');
      productInfo?.querySelectorAll('input.product-variant-id[name="id"]').forEach((input) => {
        input.value = '';
        input.disabled = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      productInfo?.querySelector('product-form')?.toggleSubmitButton(false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearInitialVariantSelections);
  } else {
    clearInitialVariantSelections();
  }
})();
